import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { BooleanOperators, Condition, Operator } from '@empathy/survey/base';

export interface IConditionForm {
  questionId: FormControl<string>;
  cardId: FormControl<string | null>;
  operator: FormControl<Operator>;
  group: FormControl<number>;
  valueToMatch?: FormControl<string[]>;
  optionId: FormControl<string | null>;
}

export class ConditionForm {
  form = new FormGroup<IConditionForm>(
    {
      questionId: new FormControl<string>(''),
      cardId: new FormControl<string | null>(null),
      operator: new FormControl<Operator>(null),
      group: new FormControl<number>(1),
      valueToMatch: new FormControl<string[]>([]),
      optionId: new FormControl<string | null>(null)
    },
    this.validateCondition()
  );

  constructor(condition?: Condition) {
    if (!condition) {
      return;
    }

    this.form.patchValue({
      ...condition,
      cardId: condition.cardId || null,
      optionId: condition.optionId || null,
      valueToMatch: (condition.valueToMatch ?? []).map((value) => (typeof value === 'number' && Number.isFinite(value) ? String(value) : value))
    });
  }

  private validateCondition(): ValidatorFn {
    return (group: FormGroup): ValidationErrors | null => {
      const questionId = group.get('questionId').value;
      if (!questionId || questionId.length === 0) {
        group.get('questionId').setErrors({ required: true });
        return { required: true };
      }

      const operator = group.get('operator').value;
      if (!operator || operator.length === 0) {
        group.get('operator').setErrors({ required: true });
        return { required: true };
      }

      if (BooleanOperators.includes(operator)) {
        return null;
      }

      const valueToMatch = group.get('valueToMatch').value;
      if (!valueToMatch || valueToMatch.length === 0) {
        group.get('valueToMatch').setErrors({ required: true });
        return { required: true };
      }
    };
  }
}
